export const en = {
  app: {
    name: 'Sine',
    tagline: 'What can I help you with?',
    placeholder: 'Send a message to Sine...',
    newChat: 'New chat',
    newTask: 'New task',
    search: 'Search',
    library: 'Library',
    projects: 'Projects',
    newProject: 'New project',
    allChats: 'All chats',
    allTasks: 'All tasks',
    agents: 'Agents',
    settings: 'Settings',
    account: 'Account',
    usage: 'Usage',
    billing: 'Billing',
    getHelp: 'Get help',
    collaborate: 'Collaborate',
    share: 'Share',
    calendar: 'Calendar',
    notifications: 'Notifications',
    closeSidebar: 'Close sidebar',
    display: 'Display',
    conversation: 'Conversation',
    help: 'Help',
  },
  chat: {
    send: 'Send',
    stop: 'Stop',
    regenerate: 'Regenerate',
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied!',
    thinking: 'Thinking...',
    model: {
      'sine-lite': 'Sine Lite',
      'sine-pro': 'Sine Pro',
      'sine-max': 'Sine Max',
      'sine-1': 'Sine Lite',
    },
    welcome: {
      title: 'What can I do for you?',
      subtitle: 'Norwegian AI assistant for chat and tasks',
    },
    suggestions: [
      'Create slides',
      'Build website',
      'Analyze data',
      'Write a report',
    ],
    uploadFile: 'Upload file',
    voiceInput: 'Voice input',
    writeCode: 'Write code',
    writeCodeFor: 'Write code for',
    close: 'Close',
    activateAgentTask: 'Activate agentic task',
    whatDoesThisSkillDo: 'What does this skill do?',
    continue: 'Continue',
    whatWouldYouLikeToBuild: 'What would you like to build?',
    whatShouldIWrite: 'What should I write?',
    whatShouldAgentDo: 'What should the agent do?',
    howCanIHelpYou: 'How can I help you?',
    describeApp: 'Describe an app, trigger, interface or automation you want to create',
    writingAgentHelp: 'The writing agent helps you with documents, reports and books',
  },
  settings: {
    title: 'Settings',
    general: 'General',
    language: 'Language',
    appearance: 'Appearance',
    dark: 'Dark',
    light: 'Light',
    followSystem: 'Follow System',
    communicationPreferences: 'Communication preferences',
    receiveUpdates: 'Receive product updates',
    receiveUpdatesDesc: 'Get early access to feature releases and success stories.',
    emailOnTask: 'Email when task starts',
    emailOnTaskDesc: "We'll send you an email once your task begins processing.",
    scheduledTasks: 'Scheduled tasks',
    emailSine: 'Email Sine',
    dataControl: 'Data control',
    personalization: 'Personalization',
    skills: 'Skills',
    connections: 'Connections',
    integrations: 'Integrations',
    agentHistory: 'Agent history',
    pushNotificationsCalendar: 'Push notifications for calendar tasks',
    pushNotificationsCalendarDesc: 'Receive in-app notifications when an agentic task is about to run or has completed.',
    autoApproveCalendar: 'Auto-approve calendar tasks',
    autoApproveCalendarDesc: 'When enabled, Sine can automatically add recurring tasks to the calendar without manual confirmation. Recommended for experienced users only.',
    saved: 'Saved ✓',
    save: 'Save',
    saving: 'Saving...',
    error: 'Error',
    notAvailable: 'Not available',
    deleteScheduledTask: 'Delete task',
    profileInfo: 'Profile information',
    emailAddress: 'Email address',
    password: 'Password',
    changePasswordDesc: 'Update your password to keep your account secure.',
    session: 'Session',
    logOut: 'Log out',
    logOutDesc: 'Log out of Sine on this device.',
    dangerZone: 'Danger zone',
    deleteAccount: 'Delete account',
    deleteAccountDesc: 'Permanently deletes your account and all associated data. This action cannot be undone.',
    delete: 'Delete',
    change: 'Change',
    aboutYou: 'About you',
    name: 'Name',
    nameDesc: 'What should Sine call you?',
    yourName: 'Your name',
    customInstructions: 'Custom instructions',
    customInstructionsDesc: 'Tell Sine about yourself, what you work with and what you are interested in. This helps Sine give you more relevant and personal answers.',
    customInstructionsPlaceholder: 'E.g. I work with tech and AI. I prefer short, direct answers...',
    transactionHistory: 'Transaction history',
    noTransactions: 'No transactions yet.',
    usedThisMonth: 'Used this month',
    availableCredits: 'Available credits',
    approachingLimit: 'You are approaching your limit.',
    addAttachment: 'Add attachment',
    terminal: 'Terminal',
    switchToAgent: 'Use tools and files',
  },
  layout: {
    back: 'Back',
    rename: 'Rename conversation',
    renamePrompt: 'Give the conversation a new name:',
    taskDetails: 'Task details',
    rateTask: 'Rate this task',
    cancel: 'Cancel',
    delete: 'Delete',
    moveToProject: 'Move to project',
    logoutConfirm: 'Are you sure you want to log out?',
    logoutAs: 'Log out of Sine as {{email}}?',
    chatMode: 'Quick answer and conversation',
    agentMode: 'Deep workflow with tools',
    powerfulForComplex: 'Powerful for complex tasks',
    connectorsSelected: '{{count}} connector{{s}} selected',
    connectorsOptional: 'Connectors (optional)',
    enterName: 'Enter name',
    whatIsCredits: 'What are credits?',
    getFeedback: 'Get help',
    taskDetailsTitle: 'Task details',
    newProject: 'New project',
  },
  connectors: {
    gmailDesc: 'Let Sine read and send emails on your behalf via Gmail.',
    email: 'Email',
    outlookDesc: 'Connect Outlook to read and send emails via your Microsoft account.',
    googleCalendarDesc: 'Let Sine view and create calendar entries in Google Calendar.',
    calendar: 'Calendar',
    slackDesc: 'Connect Slack to send messages and notifications to your channels.',
    vercelDesc: 'Let Sine deploy and manage Vercel projects.',
    cloudflareDesc: 'Connect Cloudflare for DNS management and security settings.',
    projectManagement: 'Project management',
    mondayDesc: 'Connect Monday.com for task management and team projects.',
    asanaDesc: 'Let Sine create and manage tasks in Asana.',
    airtableDesc: 'Connect Airtable to read and write to bases and tables.',
    metaDesc: 'Analyze and manage Meta ad campaigns with Sine.',
    instagramDesc: 'Manage posts and analyze engagement on Instagram.',
    zapierDesc: 'Connect Sine to thousands of apps via Zapier automation.',
    encryptedNote: 'These are stored encrypted and never sent to the client',
    githubAuthFailed: 'GitHub connection failed:',
    noAuthUrl: 'No auth_url from backend',
    gmailAuthError: 'Gmail auth-url error:',
    noGithubAuthUrl: 'No auth_url from GitHub backend:',
    githubNotConfigured: 'Could not start GitHub authentication. Check that the GitHub App is configured in Admin → Connectors.',
    githubAuthError: 'GitHub auth-url error:',
    githubConnectError: 'Error connecting to GitHub. Please try again.',
  },
  library: {
    noPreview: 'No preview available yet.',
    newConversation: 'New conversation',
    moreOptions: 'More options',
    close: 'Close',
    noContent: '# No content\n\nThis document has no saved content yet.',
    searchFiles: 'Search files',
    locateInConversations: 'Locate in conversations',
    sendToSine: 'Send to Sine',
    share: 'Share',
    download: 'Download',
    asMarkdown: 'As Markdown',
    asPdf: 'As PDF',
    asDocx: 'As DOCX',
    openOriginal: 'Open original',
    compressedFileDesc: 'Compressed file with content and attachments.',
    favorite: 'Favorite',
    removeFromFavorites: 'Remove from favorites',
    addToFavorites: 'Add to favorites',
    noFilesFound: 'No files found',
    dropFilesHere: 'Drop files here',
    allFiles: 'All files',
    images: 'Images',
    documents: 'Documents',
    code: 'Code',
    other: 'Other',
    sortBy: 'Sort by',
    date: 'Date',
    name: 'Name',
    size: 'Size',
    filterBy: 'Filter by',
    clearFilter: 'Clear filter',
    deleteFile: 'Delete file',
    deleteFileConfirm: 'Delete this file?',
    fileDeleted: 'File deleted',
    uploadFile: 'Upload file',
    uploading: 'Uploading...',
    uploadError: 'Upload failed',
    copyLink: 'Copy link',
    linkCopied: 'Link copied!',
    preview: 'Preview',
    noMemories: 'No memories yet',
    addMemory: 'Add memory',
    memoryTitle: 'Memory title',
    memoryContent: 'Memory content',
    saveMemory: 'Save memory',
    deleteMemory: 'Delete memory',
    deleteMemoryConfirm: 'Delete this memory?',
    memoryGraph: 'Knowledge graph',
    memoryList: 'Memory list',
    memoryNote: 'Memory note',
    newMemory: 'New memory',
    searchMemories: 'Search memories...',
    noMemoriesFound: 'No memories found',
    memoryDeleted: 'Memory deleted',
    memorySaved: 'Memory saved',
    collapseGraph: 'Collapse graph',
    expandGraph: 'Expand graph',
  },
  agents: {
    researchDesc: 'Searches and analyzes information from the web, compiles reports and summarizes findings.',
    researchReady: 'I am ready to search and analyze information from the web for you. What would you like me to research?',
    codeDesc: 'Writes, debugs and refactors code across all programming languages.',
    codeReady: 'I am ready to help you with code. Describe what you want to build, fix or improve.',
    dataAnalyst: 'data-analyst',
    dataDesc: 'Analyzes datasets, creates visualizations and provides insights from structured data.',
    analysis: 'Analysis',
    dataReady: 'I am ready to analyze data for you. Share a dataset or describe what you want to analyze.',
    writerDesc: 'Writes and edits documents, reports, presentations and technical content.',
    writerReady: 'I am ready to write documents for you. What do you need help writing?',
    automationTitle: 'Task automation',
    automationDesc: 'Automates repetitive tasks, plans and executes multi-step workflows.',
    automationReady: 'I am ready to automate tasks for you. Describe what you want automated.',
    failed: 'Failed',
    loadHistoryError: 'Could not load history. Please try again.',
    done: 'Done',
    waitingForInfo: 'Waiting for info',
    taskComplete: 'Task complete!',
    connectionError: 'Connection error to agent backend',
    reconnected: 'Reconnected — continuing',
    continuing: 'Continuing',
  },
  admin: {
    users: 'Users',
    analytics: 'Analytics',
    notifications: 'Notifications',
    helpCenter: 'Help center',
    settings: 'Settings',
    couldNotLoadTools: 'Could not load tools',
    toolUpdateError: 'Error updating tool',
    allToolsReset: 'All tools reset to defaults',
    resetError: 'Error resetting',
    saved: 'Saved!',
    error: 'Error:',
    networkError: 'Network error',
    deleteArticleConfirm: 'Delete this article?',
    deletePostConfirm: 'Delete this post?',
    removeAdminConfirm: 'Remove admin rights from this user?',
    emailRequired: 'Email is required',
    userAdded: 'User added!',
    savingDraft: 'Saving...',
    saveDraft: 'Save draft',
    pageViews: 'Page views (7 days)',
    bounceRate: 'Bounce rate',
    searchEmail: 'Search by email...',
    allUsers: 'Users',
    viewEditUser: 'View / edit user',
    shortDescription: 'Short description (shown in list view)',
    writeContent: 'Write content here...',
    delete: 'Delete',
    sentNotifications: 'Sent notifications',
    dataAndVisualization: 'Data & Visualization',
    editArticle: 'Edit article',
    newArticle: 'New article',
    exampleQuestion: 'E.g. What are credits and how are they used?',
    writeAnswerMarkdown: 'Write answer in Markdown format...',
    exampleSlug: 'e.g. credits-explained (auto-generated if empty)',
    deleteAllNotificationsConfirm: 'Delete all notifications?',
    emailPlaceholder: 'user@example.com',
    save: 'Save',
    saving: 'Saving...',
  },
  help: {
    searchPlaceholder: 'Search help articles...',
  },
  calendar: {
    title: 'Calendar',
    newTask: 'New task',
    editTask: 'Edit task',
    deleteTask: 'Delete task',
    deleteTaskConfirm: 'Delete this task?',
    taskDeleted: 'Task deleted',
    taskSaved: 'Task saved',
    today: 'Today',
    newEvent: 'New event',
    week: 'Week',
    month: 'Month',
    day: 'Day',
    noTasks: 'No tasks scheduled',
    schedule: 'Schedule',
    repeat: 'Repeat',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    never: 'Never',
    dueDate: 'Due date',
    priority: 'Priority',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    status: 'Status',
    pending: 'Pending',
    inProgress: 'In progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  errors: {
    apiKeyMissing: 'API key missing. Check your Sine configuration in .env',
    networkError: 'Network error. Please try again.',
    unknown: 'An unknown error occurred.',
  },
}
